import { render, staticRenderFns } from "./Artical.vue?vue&type=template&id=0a23f085"
import script from "./Artical.vue?vue&type=script&lang=js"
export * from "./Artical.vue?vue&type=script&lang=js"
import style0 from "./Artical.vue?vue&type=style&index=0&id=0a23f085&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports